class HomeVoiceSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.js-home-voice-swiper', {
      speed: 500,
      loop: true,
      slidesPerView: 1.2,
      spaceBetween: 12,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.home-voice-swiper-pagination',
        clickable: true, // クリック可能にする
      },
      navigation: {
        nextEl: '.home-voice-swiper-button-next',
        prevEl: '.home-voice-swiper-button-prev',
      },
      breakpoints: {
        768: {
          speed: 500,
          slidesPerView: 2,
          spaceBetween: 20,
        }
      },
    })
  }
}
